$('.slider').slick({
    arrows: false,
    infinite: true,
    slidesToShow:1,
    slidesToScroll:1,
    dots: true,
    adaptiveHeight: true,
    speed:1000,
    easing: 'ease'

});